import styled from 'styled-components';

export const SearchInput = styled.input`
  width: 100%;
  height: auto;
  caret-color: ${({ theme }) => theme.palette.coral};
  border: none;
  padding: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.matterHorn};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  outline: none;
  background-color: transparent;

  &::placeholder {
    font-size: 16px;
    opacity: 0.5;
    text-overflow: ellipsis;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    color: ${({ theme }) => theme.palette.matterHorn};
  }

  &:focus ::placeholder {
    font-weight: 600;
  }
  &:disabled {
    font-weight: 400;
  }
`;

export const SearchResultListItem = styled.ul`
  cursor: pointer;
  :hover {
    background-color: rgba(250, 58, 51, 0.1);
  }
`;

export const SearchResultError = styled.div`
  width: 100%;
  padding: 30px 0 35px 26px;
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: 2px;
  box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.2);

  color: ${({ theme }) => theme.palette.tomato};
  font-size: 14px;
  font-weight: 600;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    box-shadow: none;
    padding: 20px 0;
  }
`;
